{
  "schema_version": "1.0",
  "works": [
    {
      "exhibition": "hegra",
      "title": "Qasr al-Farid, the Lonely Castle",
      "photographer": "Prof. Mortel",
      "licence": "CC BY 2.0",
      "licence_url": "https://creativecommons.org/licenses/by/2.0/"
    },
    {
      "exhibition": "hegra",
      "title": "Tomb 39, Qasr al-Bint",
      "photographer": "Carole Raddato (Following Hadrian)",
      "licence": "CC BY-SA 2.0",
      "licence_url": "https://creativecommons.org/licenses/by-sa/2.0/"
    },
    {
      "exhibition": "hegra",
      "title": "The Lion Tomb",
      "photographer": "Carole Raddato (Following Hadrian)",
      "licence": "CC BY-SA 2.0",
      "licence_url": "https://creativecommons.org/licenses/by-sa/2.0/"
    },
    {
      "exhibition": "hegra",
      "title": "Tomb 21, Qasr al-Bint Necropolis",
      "photographer": "Carole Raddato (Following Hadrian)",
      "licence": "CC BY-SA 2.0",
      "licence_url": "https://creativecommons.org/licenses/by-sa/2.0/"
    },
    {
      "exhibition": "hegra",
      "title": "The Diwan, Jabal Ithlib",
      "photographer": "Prof. Mortel",
      "licence": "CC BY 2.0",
      "licence_url": "https://creativecommons.org/licenses/by/2.0/"
    },
    {
      "exhibition": "hegra",
      "title": "The Siq of Jabal Ithlib",
      "photographer": "Prof. Mortel",
      "licence": "CC BY 2.0",
      "licence_url": "https://creativecommons.org/licenses/by/2.0/"
    },
    {
      "exhibition": "hegra",
      "title": "Nabataean Inscriptions at Jabal Ithlib",
      "photographer": "Prof. Mortel",
      "licence": "CC BY 2.0",
      "licence_url": "https://creativecommons.org/licenses/by/2.0/"
    },
    {
      "exhibition": "hegra",
      "title": "The Plain of Hegra",
      "photographer": "Prof. Mortel",
      "licence": "CC BY 2.0",
      "licence_url": "https://creativecommons.org/licenses/by/2.0/"
    },
    {
      "exhibition": "jubbah",
      "title": "The King of Jubbah",
      "photographer": "Prof. Mortel",
      "licence": "CC BY 2.0",
      "licence_url": "https://creativecommons.org/licenses/by/2.0/"
    },
    {
      "exhibition": "jubbah",
      "title": "Chariot with Two Horses",
      "photographer": "Prof. Mortel",
      "licence": "CC BY 2.0",
      "licence_url": "https://creativecommons.org/licenses/by/2.0/"
    },
    {
      "exhibition": "jubbah",
      "title": "Figures and Herds",
      "photographer": "Prof. Mortel",
      "licence": "CC BY 2.0",
      "licence_url": "https://creativecommons.org/licenses/by/2.0/"
    },
    {
      "exhibition": "jubbah",
      "title": "Ibex Panel",
      "photographer": "Prof. Mortel",
      "licence": "CC BY 2.0",
      "licence_url": "https://creativecommons.org/licenses/by/2.0/"
    },
    {
      "exhibition": "jubbah",
      "title": "Panel at Jabal Umm Sinman",
      "photographer": "Prof. Mortel",
      "licence": "CC BY 2.0",
      "licence_url": "https://creativecommons.org/licenses/by/2.0/"
    },
    {
      "exhibition": "jubbah",
      "title": "Overlapping Engravings",
      "photographer": "Prof. Mortel",
      "licence": "CC BY 2.0",
      "licence_url": "https://creativecommons.org/licenses/by/2.0/"
    },
    {
      "exhibition": "jubbah",
      "title": "Hunter and Dog",
      "photographer": "Prof. Mortel",
      "licence": "CC BY 2.0",
      "licence_url": "https://creativecommons.org/licenses/by/2.0/"
    },
    {
      "exhibition": "jubbah",
      "title": "Engraved Rock Face, Jubbah",
      "photographer": "Prof. Mortel",
      "licence": "CC BY 2.0",
      "licence_url": "https://creativecommons.org/licenses/by/2.0/"
    },
    {
      "exhibition": "turaif",
      "title": "At-Turaif District, Diriyah",
      "photographer": "Prof. Mortel",
      "licence": "CC BY 2.0",
      "licence_url": "https://creativecommons.org/licenses/by/2.0/"
    },
    {
      "exhibition": "turaif",
      "title": "Earthen Walls of At-Turaif",
      "photographer": "Wikimedia Commons contributor",
      "licence": "CC BY 3.0 PL",
      "licence_url": "https://creativecommons.org/licenses/by/3.0/pl/"
    },
    {
      "exhibition": "turaif",
      "title": "Courtyard and Tower, At-Turaif",
      "photographer": "Wikimedia Commons contributor",
      "licence": "CC BY 3.0 PL",
      "licence_url": "https://creativecommons.org/licenses/by/3.0/pl/"
    },
    {
      "exhibition": "turaif",
      "title": "Street in At-Turaif",
      "photographer": "Wikimedia Commons contributor",
      "licence": "CC BY 3.0 PL",
      "licence_url": "https://creativecommons.org/licenses/by/3.0/pl/"
    },
    {
      "exhibition": "turaif",
      "title": "Parapets Against the Sky",
      "photographer": "Wikimedia Commons contributor",
      "licence": "CC BY 3.0 PL",
      "licence_url": "https://creativecommons.org/licenses/by/3.0/pl/"
    },
    {
      "exhibition": "turaif",
      "title": "At-Turaif Restored",
      "photographer": "Wikimedia Commons contributor",
      "licence": "CC0",
      "licence_url": "https://creativecommons.org/publicdomain/zero/1.0/"
    },
    {
      "exhibition": "turaif",
      "title": "Ardah, the Najdi Sword Dance",
      "photographer": "Wikimedia Commons contributor",
      "licence": "CC BY-SA 4.0",
      "licence_url": "https://creativecommons.org/licenses/by-sa/4.0/"
    },
    {
      "exhibition": "turaif",
      "title": "Masmak Fortress, Riyadh",
      "photographer": "Sammy Six",
      "licence": "CC BY 2.0",
      "licence_url": "https://creativecommons.org/licenses/by/2.0/"
    },
    {
      "exhibition": "al-ahsa",
      "title": "Jabal Al-Qarah",
      "photographer": "Dr. Ondřej Havelka (cestovatel)",
      "licence": "CC BY 4.0",
      "licence_url": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
      "exhibition": "al-ahsa",
      "title": "The Cliffs of Jabal Al-Qarah",
      "photographer": "Richard Mortel from Riyadh, Saudi Arabia",
      "licence": "CC BY 2.0",
      "licence_url": "https://creativecommons.org/licenses/by/2.0/"
    },
    {
      "exhibition": "al-ahsa",
      "title": "Inside the Cave",
      "photographer": "Aqeel Khalid",
      "licence": "CC BY-SA 4.0",
      "licence_url": "https://creativecommons.org/licenses/by-sa/4.0/"
    },
    {
      "exhibition": "al-ahsa",
      "title": "Palm Grove at Hofuf",
      "photographer": "King Eliot",
      "licence": "CC BY-SA 4.0",
      "licence_url": "https://creativecommons.org/licenses/by-sa/4.0/"
    },
    {
      "exhibition": "al-ahsa",
      "title": "Ibrahim Palace, Hofuf",
      "photographer": "Heritage Commission",
      "licence": "CC BY-SA 4.0",
      "licence_url": "https://creativecommons.org/licenses/by-sa/4.0/"
    },
    {
      "exhibition": "al-ahsa",
      "title": "Qasr Sahoud",
      "photographer": "Heritage Commission",
      "licence": "CC BY-SA 4.0",
      "licence_url": "https://creativecommons.org/licenses/by-sa/4.0/"
    },
    {
      "exhibition": "al-ahsa",
      "title": "Qaisariah Souq",
      "photographer": "saudipics",
      "licence": "CC BY-SA 4.0",
      "licence_url": "https://creativecommons.org/licenses/by-sa/4.0/"
    },
    {
      "exhibition": "al-ahsa",
      "title": "The Oldest Mosque in Al-Ahsa",
      "photographer": "Dr. Ondřej Havelka (cestovatel)",
      "licence": "CC BY 4.0",
      "licence_url": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
      "exhibition": "rijal-almaa",
      "title": "Rijal Almaa from the Valley",
      "photographer": "Richard Mortel",
      "licence": "CC BY 2.0",
      "licence_url": "https://creativecommons.org/licenses/by/2.0/"
    },
    {
      "exhibition": "rijal-almaa",
      "title": "Tower Houses",
      "photographer": "Heritage Commission",
      "licence": "CC BY-SA 4.0",
      "licence_url": "https://creativecommons.org/licenses/by-sa/4.0/"
    },
    {
      "exhibition": "rijal-almaa",
      "title": "Stone Courses and Quartz",
      "photographer": "Heritage Commission",
      "licence": "CC BY-SA 4.0",
      "licence_url": "https://creativecommons.org/licenses/by-sa/4.0/"
    },
    {
      "exhibition": "rijal-almaa",
      "title": "The Village Rising",
      "photographer": "Rehaamassiry",
      "licence": "CC BY-SA 4.0",
      "licence_url": "https://creativecommons.org/licenses/by-sa/4.0/"
    },
    {
      "exhibition": "rijal-almaa",
      "title": "Within the Village",
      "photographer": "Richard Mortel",
      "licence": "CC BY 2.0",
      "licence_url": "https://creativecommons.org/licenses/by/2.0/"
    },
    {
      "exhibition": "rijal-almaa",
      "title": "A Painted Interior",
      "photographer": "Richard Mortel",
      "licence": "CC BY 2.0",
      "licence_url": "https://creativecommons.org/licenses/by/2.0/"
    },
    {
      "exhibition": "rijal-almaa",
      "title": "Al-Qatt Al-Asiri",
      "photographer": "Richard Mortel",
      "licence": "CC BY 2.0",
      "licence_url": "https://creativecommons.org/licenses/by/2.0/"
    },
    {
      "exhibition": "rijal-almaa",
      "title": "Rijal Almaa Museum",
      "photographer": "Muhammad Sobri",
      "licence": "CC BY-SA 4.0",
      "licence_url": "https://creativecommons.org/licenses/by-sa/4.0/"
    }
  ],
  "typefaces": [
    {
      "name": "Reem Kufi",
      "role": "Arabic display — drawn from Kufic architectural inscriptions",
      "copyright": "2015-2022 The Reem Kufi Project Authors (https://github.com/aliftype/reem-kufi), with Reserved Font Name \"Josefin Sans\"."
    },
    {
      "name": "Marcellus",
      "role": "Latin display — inscriptional Roman capitals",
      "copyright": "(c) 2012, Brian J. Bonislawsky DBA Astigmatic (AOETI) (astigma@astigmatic.com), with Reserved Font Names \"Marcellus\""
    },
    {
      "name": "IBM Plex Sans Arabic",
      "role": "Body and interface, both scripts",
      "copyright": "© 2017 IBM Corp. with Reserved Font Name \"Plex\""
    }
  ]
}
